export default "<change-password params=\"isLogin: true, changePasswordToken: changePasswordToken\"></change-password>";